import { Divider, Flex, Form } from "antd";

import { ConfirmOtpModal } from "components/ConfirmOtpModal";
import { OPERATION_TYPE } from "interfaces";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton, NumberInput } from "ui";
import { _greaterOrEqual, _isRequired, _lessOrEqual, requestWithNotify, RUB_CURRENCY } from "utils";

import { OtpModalTitle } from "./PayoutOtpModal/OtpModalTitle";
import { OtpModalDescription } from "./PayoutOtpModal/OtpModalDescription";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";
import { useEffect, useMemo } from "react";
import { useNotificationContext } from "providers";
import { NOMINAL_ACCOUNT_REQUESTS_DELAY } from "constants/nominalAccount";

export const PayoutModal = observer(() => {
  const { actionModals, nominalAccounts } = useStores();
  const { openNotification } = useNotificationContext();

  const [form] = Form.useForm();
  const inputValue = Form.useWatch("amount", form);

  const disabled = inputValue <= 0 || inputValue > nominalAccounts.userBalances.data.availableBalance;
  const description = useMemo(() => <OtpModalDescription />, []);

  const showOtpModalHandler = () => {
    const values = form.getFieldsValue();
    const amount = form.getFieldValue("amount");

    actionModals.open(
      () => (
        <ConfirmOtpModal
          notificationMsg={{
            successMsg: "Заявка на вывод успешно создана",
            errorMsg: "Ошибка. Заявка не создана",
          }}
          title={<OtpModalTitle amount={amount} />}
          description={description}
          operationPath={OPERATION_TYPE.RUB_WITHDRAWAL_REQUEST}
          requestBody={{
            ...values,
            amount,
          }}
        />
      ),
      {
        width: "600px",
        title: "Подтвердите вывод средств",
        onClose: () => {
          handleCloseModal();
          requestWithNotify({
            fetchFn: () => nominalAccounts.fetchAllBalances({ rubOperationsFetch: false }),
            openNotification: openNotification,
            delay: NOMINAL_ACCOUNT_REQUESTS_DELAY,
          });
        },
      }
    );
  };

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  useEffect(() => {
    if (nominalAccounts.userBalances.data.availableBalance) {
      form.setFieldValue("amount", nominalAccounts.userBalances.data.availableBalance);
    }
  }, [nominalAccounts.userBalances.data.availableBalance]);

  return (
    <Flex vertical gap="large">
      <Divider className="margin-top-none margin-bottom-none" />
      <Form form={form} onFinish={() => showOtpModalHandler()}>
        <Form.Item
          name="amount"
          className="full-width"
          validateDebounce={FORM_VALIDATION_DEBOUNCE}
          rules={[
            _isRequired("Поле обязательно для ввода"),
            _greaterOrEqual(0),
            _lessOrEqual(
              nominalAccounts.userBalances.data.availableBalance,
              `Сумма должна быть меньше или равна ${nominalAccounts.userBalances.data.availableBalance} ${RUB_CURRENCY.RUB}`
            ),
          ]}
        >
          <NumberInput placeholder="Введите сумму для вывода в рублях" />
        </Form.Item>

        <Form.Item>
          <Flex gap="large">
            <CustomButton onClick={handleCloseModal} variant="outlined" fullWidth>
              Отмена
            </CustomButton>
            <CustomButton fullWidth htmlType="submit" disabled={disabled}>
              Подтвердить
            </CustomButton>
          </Flex>
        </Form.Item>
      </Form>
    </Flex>
  );
});
